<div
  class="flex items-center justify-center min-h-[calc(100vh-4rem)] bg-white px-4"
>
  <div class="relative w-full max-w-[400px] border border-dc-navy mt-10">
    @if (!isSuccess) {
      <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
        <div class="mx-auto w-full max-w-lg">
          <h1 class="text-3xl font-bold text-center text-dc-navy mb-6">
            {{ "FORGOT_USERNAME_TITLE" | translate }}
          </h1>
          <label class="text-dc-navy font-semibold mb-4 block">
            {{ "FORGOT_USERNAME_DESCRIPTION" | translate }}
          </label>

          <form [formGroup]="recoverForm" (ngSubmit)="submit()">
            <div class="field-control">
              <label class="field-label font-bold">
                {{ "FORGOT_USERNAME_EMAIL" | translate }}
              </label>
              <app-text-field
                [label]="''"
                [hideLabel]="true"
                [control]="recoverForm.get('email')!"
                [maxlength]="120"
              ></app-text-field>
            </div>

            @if (showErrorMsg) {
            <div class="mb-6">
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'VALIDATION_MSG.EMAIL_NOT_REGISTERED' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
            </div>
          }

            <div class="field-control">
              <app-button
                type="submit"
                classesName="btn-primary-big w-full mb-4"
                class="block w-full"
                [label]="'FORGOT_USERNAME_NEXT' | translate"
                [disabled]="isSubmitting"
              ></app-button>
              <app-button
                type="button"
                classesName="card-edge-cut-white btn-primary-big w-full"
                class="block w-full"
                [label]="'FORGOT_USERNAME_CANCEL' | translate"
                (onBtnClick)="cancel()"
              ></app-button>
            </div>
          </form>
        </div>
      </div>
    } @else {
      <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
        <div class="mx-auto w-full max-w-lg text-center text-dc-navy">
          <h1 class="text-3xl font-bold mb-6">
            {{ "FORGOT_USERNAME_SUCCESS_TITLE" | translate }}
          </h1>
          <p class="text-lg font-semibold mb-8">
            {{ "FORGOT_USERNAME_SUCCESS_MESSAGE" | translate }}
          </p>
          <button
            type="button"
            class="text-dc-navy font-bold"
            (click)="backToApplication()"
          >
            <span class="me-2">‹</span>
            {{ "FORGOT_USERNAME_BACK" | translate }}
          </button>
          <p class="text-lg font-semibold mt-8">
            {{ "FORGOT_USERNAME_ASSIST" | translate }}
            <a class="underline" href="mailto:{{ supportEmail }}">{{
              supportEmail
            }}</a>
          </p>
        </div>
      </div>
    }
  </div>
</div>
